module.exports = __webpack_public_path__ + "img/volume_up.74c8656b.svg";